import api from "./base-api"

const dsUserApi = api.injectEndpoints({
    endpoints: (build) => ({
        searchDsUserIds: build.query({
            query: ({
                sTransactionId = ""
            }) => `v2/ds/users/search?sTransactionId=${sTransactionId}`
        })
    })
})

export const {
    useSearchDsUserIdsQuery
} = dsUserApi
